import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "edit-props-container form-container"
};
const _hoisted_2 = {
  class: "props-list"
};
const _hoisted_3 = {
  class: "prop-content"
};
const _hoisted_4 = {
  class: "props-list"
};
const _hoisted_5 = {
  class: "prop-content"
};
const _hoisted_6 = {
  key: 0,
  class: "operator-container"
};
const _hoisted_7 = {
  key: 1,
  class: "operator-container"
};
import { ref, onMounted, computed } from 'vue';
import { ElButton, ElCol, ElForm, ElInput, ElInputNumber, ElMessage, ElOption, ElRow, ElSelect } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
import { getPropsRareLevelDesc } from '@/tools/utils';
import RoleFinder from '@/components/Role/RoleFinder.vue'; // constants

export default {
  __name: 'RolePropsEditCard',
  props: {
    rolePropId: {
      type: [String, Number, null],
      default: () => null,
      required: false
    }
  },
  emits: ['close', 'reload'],

  setup(__props, {
    emit: __emit
  }) {
    const bindingTypes = [{
      'id': 1,
      'name': '当前选中者'
    }, {
      'id': 2,
      'name': '仅当前角色'
    }, {
      'id': 3,
      'name': '演出中绑定'
    }];
    const fortifyTypes = [{
      'id': 0,
      'name': '不可强化'
    }, {
      'id': 1,
      'name': '可强化'
    }, {
      'id': 2,
      'name': '仍可强化'
    }, {
      'id': 3,
      'name': '已强化'
    }];
    const rareLevels = [{
      'id': 1,
      'value': 0
    }, {
      'id': 2,
      'value': 1
    }, {
      'id': 3,
      'value': 2
    }, {
      'id': 4,
      'value': 3
    }, {
      'id': 5,
      'value': 4
    }];
    const statusArray = [{
      'id': 0,
      'name': '准备中'
    }, {
      'id': 1,
      'name': '进行中'
    }, {
      'id': 2,
      'name': '已完成'
    }]; // pre-declaration

    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const loading = ref(false);
    const rolePropForm = ref({
      id: null,
      times: 0,
      name: '',
      appearance_desc: '',
      function_desc: '',
      cost: '',
      mysterious_level: 0,
      rare_level: 0,
      price: 0.0,
      weight: 0.0,
      enchant: false,
      fortify: 0,
      identified: false,
      detachable: false,
      deep_desc: '',
      type: null,
      tag: null,
      cooldown: null,
      timing_type: null,
      binding_type: null,
      enable: true
    });
    const source = ref(null);
    const role = ref(null);
    const performance = ref(null);
    const performances = ref([]);
    const similarProps = ref([]); // computed

    const worldOutlook = computed(() => store.state.world_outlook);
    const cdTypes = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.cd_types ?? null;
    });
    const timingTypes = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.timing_types ?? null;
    });
    const propsTypes = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.props_types ?? null;
    });
    const propsTags = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.props_tags ?? null;
    }); // functions

    const getData = () => {
      if (!worldOutlook.value) return;
      if (!propsTypes.value) store.dispatch('get_props_types');
      if (!propsTags.value) store.dispatch('get_props_tags');

      if (!cdTypes.value) {
        request('world_outlook/get_cooldown_types/', {}, 'GET').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_wo_info', {
              wo_id: worldOutlook.value.id,
              key: 'cd_types',
              value: response.data
            });
          }
        });
      }

      if (!timingTypes.value) {
        request('world_outlook/get_timing_types/', {}, 'GET').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_wo_info', {
              wo_id: worldOutlook.value.id,
              key: 'timing_types',
              value: response.data
            });
          }
        });
      }

      if (props.rolePropId) {
        request('props/role_props/get/', {
          'prop_id': props.rolePropId
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            loadData(response.data);
          }
        });
      }
    };

    const loadData = roleProp => {
      rolePropForm.value = {
        id: roleProp.id,
        times: roleProp.times ?? 0,
        name: roleProp.name,
        appearance_desc: roleProp.appearance_desc,
        function_desc: roleProp.function_desc,
        deep_desc: roleProp.deep_desc,
        cost: roleProp.cost,
        mysterious_level: roleProp.mysterious_level,
        rare_level: roleProp.rare_level,
        price: roleProp.price,
        weight: roleProp.weight,
        enchant: roleProp.enchant.toString().toUpperCase() === 'TRUE',
        fortify: roleProp.fortify,
        identified: roleProp.identified.toString().toUpperCase() === 'TRUE',
        detachable: roleProp.detachable.toString().toUpperCase() === 'TRUE',
        type: roleProp.type.id,
        tag: roleProp.tag.id,
        cooldown: roleProp.cooldown ? roleProp.cooldown.id : null,
        timing_type: roleProp.timing_type ? roleProp.timing_type.id : null,
        binding_type: roleProp.binding_type ? roleProp.binding_type.id : null,
        enable: roleProp.enable.toString().toUpperCase() === 'TRUE'
      };

      if (roleProp.source && roleProp.performance && roleProp.performance.id) {
        source.value = roleProp.performance.id;
      }
    };

    const updateSelectedRole = (item, isSelected = false) => {
      // console.log('castChanged', item.nickname, isSelected)
      if (isSelected) {
        role.value = item.id;
      } else {
        role.value = null;
      }
    };

    const getPerformances = () => {
      if (worldOutlook.value.id) {
        loading.value = true;
        request('world_outlook/get_wo_performances/', {
          'world_outlook_id': worldOutlook.value.id,
          'status_array': [2],
          'size': 20,
          'is_precis': true
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            performances.value = response.data.performances;
          }

          loading.value = false;
        });
      }
    };

    const getPerformanceDesc = item => {
      // console.log(JSON.stringify(item))
      return `${item.drama.name} / ${item.anchor.name} / ${item.start_date} / ${statusArray[item.status].name}`;
    };

    const getSimilarProps = () => {
      if (rolePropForm.value.type && rolePropForm.value.tag) {
        request('props/market_props/list/', {
          'world_outlook_id': worldOutlook.value.id,
          'select_type': rolePropForm.value.type,
          'select_tag': rolePropForm.value.tag,
          'size': props.rolePropId ? 10 : 6
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            similarProps.value = response.data.props;
          }
        });
      }
    };

    const createRoleProp = () => {
      if (message.value) {
        message.value.close();
      }

      if (!role.value) {
        message.value = ElMessage.error({
          message: '需要指定持有者',
          duration: 1500
        });
        return;
      }

      let parameters = rolePropForm.value;
      parameters.world_outlook_id = worldOutlook.value.id;
      parameters.role_id = role.value;
      if (performance.value) parameters.performance_id = performance.value;
      request('props/role_props/create/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '道具项已创建',
          duration: 1500
        });
        emits('reload');
        emits('close');
      });
    };

    const updateRoleProp = () => {
      if (message.value) {
        message.value.close();
      }

      request('props/role_props/update/', {
        'updates': rolePropForm.value
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '道具信息已调整',
          duration: 1500
        });
        emits('reload');
        emits('close');
      });
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElForm), {
        model: rolePropForm.value,
        "label-width": "auto"
      }, {
        default: _withCtx(() => [!__props.rolePropId ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 0,
          class: "form-row",
          style: {
            "align-items": "flex-start"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            span: 14
          }, {
            default: _withCtx(() => [_createVNode(RoleFinder, {
              "close-on-click": true,
              "option-number": 6,
              onSelectedRole: updateSelectedRole
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 9
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_createVNode(_unref(ElButton), {
                onClick: getSimilarProps
              }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode(" 获取同类道具情况 ", -1)]))]),
                _: 1
              })]),
              _: 1
            }), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(similarProps.value, (item, key) => {
              return _openBlock(), _createElementBlock("div", {
                key: key,
                class: "prop-card"
              }, [_createElementVNode("text", _hoisted_3, _toDisplayString(item.name) + " / 售" + _toDisplayString(item.price.toFixed(1)), 1)]);
            }), 128))])]),
            _: 1
          })]),
          _: 1
        })) : (_openBlock(), _createBlock(_unref(ElRow), {
          key: 1,
          class: "form-row",
          style: {
            "align-items": "flex-start"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), null, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_createVNode(_unref(ElButton), {
                onClick: getSimilarProps
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode(" 获取同类道具情况 ", -1)]))]),
                _: 1
              })]),
              _: 1
            }), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(similarProps.value, (item, key) => {
              return _openBlock(), _createElementBlock("div", {
                key: key,
                class: "prop-card"
              }, [_createElementVNode("text", _hoisted_5, _toDisplayString(item.name) + " / 售" + _toDisplayString(item.price.toFixed(1)), 1)]);
            }), 128))])]),
            _: 1
          })]),
          _: 1
        })), !__props.rolePropId ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 2,
          class: "form-row",
          style: {
            "align-items": "flex-end"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            offset: 0,
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "来源演出（非必须）",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: performance.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => performance.value = $event),
                placeholder: "选择一个演出作为道具来源",
                "no-data-text": "无数据",
                filterable: "",
                remote: "",
                clearable: "",
                "popper-class": "dramaPopper",
                "remote-method": getPerformances,
                loading: loading.value
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(performances.value, (item, index) => {
                  return _openBlock(), _createBlock(_unref(ElOption), {
                    key: index,
                    label: getPerformanceDesc(item),
                    value: item['id']
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue", "loading"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), _cache[23] || (_cache[23] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "道具名称",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInput), {
                modelValue: rolePropForm.value.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => rolePropForm.value.name = $event),
                maxlength: "16",
                placeholder: "道具名称",
                type: "text",
                clearable: "",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 2,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "道具类型",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: rolePropForm.value.type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => rolePropForm.value.type = $event),
                placeholder: "道具类型",
                "no-data-text": "无数据"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propsTypes.value, item => {
                  return _openBlock(), _createBlock(_unref(ElOption), {
                    key: item.id,
                    label: item.desc,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "道具标签",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: rolePropForm.value.tag,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => rolePropForm.value.tag = $event),
                placeholder: "道具标签",
                "no-data-text": "无数据"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propsTags.value, item => {
                  return _openBlock(), _createBlock(_unref(ElOption), {
                    key: item.id,
                    label: item.desc,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 2,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "限定次数",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
                modelValue: rolePropForm.value.times,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => rolePropForm.value.times = $event),
                min: 0,
                max: 100,
                precision: 0,
                placeholder: "限定次数"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "绑定类型",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: rolePropForm.value.binding_type,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => rolePropForm.value.binding_type = $event),
                placeholder: "绑定类型",
                clearable: "",
                "no-data-text": "无数据"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(bindingTypes, (item, index) => {
                  return _createVNode(_unref(ElOption), {
                    key: index,
                    label: item['name'],
                    value: item['id']
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "使用消耗（无主要效果消耗时不填）",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInput), {
                modelValue: rolePropForm.value.cost,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => rolePropForm.value.cost = $event),
                maxlength: "16",
                placeholder: "道具消耗",
                type: "text",
                clearable: "",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 2,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "估价",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
                modelValue: rolePropForm.value.price,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => rolePropForm.value.price = $event),
                min: 0,
                max: 200,
                precision: 1,
                step: 0.1,
                placeholder: "估价"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "重量（KG）",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
                modelValue: rolePropForm.value.weight,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => rolePropForm.value.weight = $event),
                min: 0,
                max: 500,
                precision: 1,
                step: 0.1,
                placeholder: "重量（KG）"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 2,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "稀有度",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: rolePropForm.value.rare_level,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => rolePropForm.value.rare_level = $event),
                placeholder: "稀有度",
                "no-data-text": "无数据"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(rareLevels, (item, index) => {
                  return _createVNode(_unref(ElOption), {
                    key: index,
                    label: _unref(getPropsRareLevelDesc)(item.value),
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "神秘等级",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
                modelValue: rolePropForm.value.mysterious_level,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => rolePropForm.value.mysterious_level = $event),
                min: 0,
                max: 20,
                precision: 0,
                placeholder: "神秘等级"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "冷却时间",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: rolePropForm.value.cooldown,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => rolePropForm.value.cooldown = $event),
                placeholder: "冷却时间",
                clearable: "",
                "no-data-text": "无数据"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cdTypes.value, (item, index) => {
                  return _openBlock(), _createBlock(_unref(ElOption), {
                    key: index,
                    label: item.desc,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发动时机",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: rolePropForm.value.timing_type,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => rolePropForm.value.timing_type = $event),
                placeholder: "发动时机",
                clearable: "",
                "no-data-text": "无数据"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timingTypes.value, (item, index) => {
                  return _openBlock(), _createBlock(_unref(ElOption), {
                    key: index,
                    label: item.desc,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "强化状态",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: rolePropForm.value.fortify,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => rolePropForm.value.fortify = $event),
                placeholder: "强化状态",
                "no-data-text": "无数据"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(fortifyTypes, (item, index) => {
                  return _createVNode(_unref(ElOption), {
                    key: index,
                    label: item['name'],
                    value: item['id']
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 2,
            span: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "常态灵能状态",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElButton), {
                class: _normalizeClass(['change-button', rolePropForm.value.enchant ? 'active-change-button' : '']),
                onClick: _cache[14] || (_cache[14] = $event => rolePropForm.value.enchant = !rolePropForm.value.enchant)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(rolePropForm.value.enchant ? '展现灵能' : '隐藏灵能'), 1)]),
                _: 1
              }, 8, ["class"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "鉴定状态",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElButton), {
                class: _normalizeClass(['change-button', rolePropForm.value.identified ? 'active-change-button' : '']),
                onClick: _cache[15] || (_cache[15] = $event => rolePropForm.value.identified = !rolePropForm.value.identified)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(rolePropForm.value.identified ? '已鉴定' : '未鉴定'), 1)]),
                _: 1
              }, 8, ["class"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "可拆解性",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElButton), {
                class: _normalizeClass(['change-button', rolePropForm.value.detachable ? 'active-change-button' : '']),
                onClick: _cache[16] || (_cache[16] = $event => rolePropForm.value.detachable = !rolePropForm.value.detachable)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(rolePropForm.value.detachable ? '可拆解' : '无拆解'), 1)]),
                _: 1
              }, 8, ["class"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "物品状态",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElButton), {
                class: _normalizeClass(['change-button', rolePropForm.value.enable ? 'active-change-button' : '']),
                onClick: _cache[17] || (_cache[17] = $event => rolePropForm.value.enable = !rolePropForm.value.enable)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(rolePropForm.value.enable ? '可用' : '残损'), 1)]),
                _: 1
              }, 8, ["class"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: rolePropForm.value.appearance_desc,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => rolePropForm.value.appearance_desc = $event),
            type: "textarea",
            clearable: "",
            "show-word-limit": "",
            round: "",
            placeholder: "道具形态描述",
            maxlength: "256"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: rolePropForm.value.function_desc,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => rolePropForm.value.function_desc = $event),
            type: "textarea",
            clearable: "",
            "show-word-limit": "",
            round: "",
            placeholder: "道具性能描述",
            maxlength: "256"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: rolePropForm.value.deep_desc,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => rolePropForm.value.deep_desc = $event),
            type: "textarea",
            clearable: "",
            "show-word-limit": "",
            round: "",
            placeholder: "道具深层描述",
            maxlength: "256"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), __props.rolePropId ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_unref(ElButton), {
        onClick: updateRoleProp
      }, {
        default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode(" 提交变更 ", -1)]))]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_unref(ElButton), {
        onClick: createRoleProp
      }, {
        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" 创建角色道具 ", -1)]))]),
        _: 1
      })]))]);
    };
  }

};